import { useState, useEffect } from 'react'

import JsonData from '../../../../data/data.json'


import { Navigation } from '../../../navigation'


import Footer from '../../../footer'
import { Attenabout } from './attenabout'
import { Attenben } from './attenben'
import { Attenpics } from './attenpic'
import { AttContact } from './contact'
import { AttendanceHeader } from './attendanceheader'
import { LiveIDUseCases } from './Liveidusecases'



const Attenfirstpage = () => {
  const [landingPageData, setLandingPageData] = useState({})
  useEffect(() => {
    setLandingPageData(JsonData)
    window.scrollTo(0, 0);
  }, [])

  return (
    <div >
   <Navigation></Navigation>
     <AttendanceHeader></AttendanceHeader>
     <Attenabout></Attenabout>
          <LiveIDUseCases/>
     <Attenben></Attenben>
     <Attenpics></Attenpics>

     <AttContact></AttContact>
    <Footer/>
    </div>
  )
}

export default Attenfirstpage
